import Rollbar from 'rollbar';

let environment = process.env.NODE_ENV;

const configure = () => {
  if (process.env.ENV_STAGING === 'true') {
    environment = 'staging';
  } else if (process.env.ENV_DEMO === 'true') {
    environment = 'demo';
  }

  window.Rollbar = new Rollbar({
    accessToken: '0714bc4786cd49a89091a3f2d860ef33',
    captureUncaught: true,
    captureUnhandledRejections: true,
    payload: {
      environment,
    },
    transform: rawPayload => {
      const payload = rawPayload;
      // Add the FullStory session URL to the Rollbar payload
      if (window.FS && window.FS.getCurrentSessionURL) {
        payload.fullstorySessionURL = window.FS.getCurrentSessionURL(true);
      }

      // Add the Heap User ID and Session ID to the Rollbar payload
      if (window.heap && window.heap.userId) {
        payload.heapUserId = window.heap.userId;
        payload.heapSessionId = window.heap.getSessionId();
      }
      return payload;
    },
  });
};

const getConsoleFunc = level =>
  ({
    warning: console.warn,
    critical: console.error,
  }[level] || console[level]);

const sendToRollbar = (level, message, params = {}) => {
  if (environment === 'development') {
    const consoleFunc = getConsoleFunc(level);
    consoleFunc(`${level.toUpperCase()}: ${message}`, params);
  }

  window.Rollbar[level](message, params);
};

const debug = (message, params = {}) => {
  sendToRollbar('debug', message, params);
};

const info = (message, params = {}) => {
  sendToRollbar('info', message, params);
};

const warning = (message, params = {}) => {
  sendToRollbar('warning', message, params);
};

const error = (message, params = {}) => {
  sendToRollbar('error', message, params);
};

const critical = (message, params = {}) => {
  sendToRollbar('critical', message, params);
};

export default {
  configure,
  debug,
  info,
  warning,
  error,
  critical,
};
